import { INotificationStoreSegment } from './notification.interface';

export const notificationStoreSelector = (state: INotificationStoreSegment) => state.notification;
